import PromoShow from './PromoShow'
export {PromoShow}
export default PromoShow
